import GetFupOrganisationLogoRequestModelBase from '../_generated/modelBases/get-fup-organisation-logo-request-model-base';

export default class GetFupOrganisationLogoRequestModel extends GetFupOrganisationLogoRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
